// import ModalForm from "./Form";
import MarketingHdykTableForm from "./MarketingHdykTableForm";
import {
	CUSTOMER_MARKETING_CHANNEL,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const Schema = {
	components: { MarketingHdykTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint:
				CUSTOMER_MARKETING_CHANNEL +
				"?clc_id_number=" +
				this.value.clc_id_number,
			tableId: "marketing-hdyk-table",
			formId: "marketing-hdyk-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Marketing Channel",
					type: "custom-html",
					key: "marketing_channel",
					isVisible: true,
					modifier: (value) => {
						if (value && value.name) {
							return `<span>${this.$t(value.name)}</span>`;
						}
					},
				},
				{
					title: "Channel Name",
					type: "text",
					key: "channel_name",
				},
			],
			actionObj: {},
			options: {
				name: "MarketingHdykTable",
				url:
					CUSTOMER_MARKETING_CHANNEL +
					"?clc_id_number=" +
					this.value.clc_id_number,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
